import { render, staticRenderFns } from "./PlaceCard.vue?vue&type=template&id=63feef16"
import script from "./PlaceCard.vue?vue&type=script&lang=js"
export * from "./PlaceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports